const instagramAccounts = (state = {}, action) => {
  switch (action.type) {
    case "SET_INSTAGRAM_ACCOUNTS":
      return action.accounts;
    case "LOG_OUT":
      return [];
    default:
      return state;
  }
};

export default instagramAccounts;
